<template>
    <div class="modal fade" id="myModal">
        <div class="modal-dialog">
            <div class="modal-content">

                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title">Consultation request for {{value.refsname}}</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <!-- 模态框主体 -->
                <div class="modal-body">
                    <form>
                        <input type="hidden" :value="value.refsid">
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Title</label>
                            <input type="text" v-model="value.advisorytitle" class="col-md-6 form-control col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Content</label>
                            <textarea v-model="value.advisorycontent" maxlength="400"
                                      class="form-control col-8"></textarea>
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc">Unit with demand</label>
                            <input type="text" v-model="value.advisorycompany" class="col-md-6 form-control col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>User name</label>
                            <input type="text" v-model="value.advisoryname" class="col-md-6 form-control col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Mobile number</label>
                            <input type="phone" v-model="value.advisoryphone" class="col-md-6 form-control col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Email</label>
                            <input v-model="value.advisoryemail" class="col-md-6 form-control col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc">Address</label>
                            <input type="text" v-model="value.advisoryaddress" class="col-md-6  col-8">
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-3 col-4 tc">Verification Code</label>
                            <input type="text" v-model="value.advisorycapat" placeholder="Verification"
                                   class="col-md-2 form-control col-8">
                            <img @click='refresh()' :src="codeUrl" id="code" class="border ml-3"
                                 style="line-height: 38px;" alt="Verification"
                                 width="65px" height="38px">

                        </div>
                        <div class="w-100 tc mt-3 mb-3">
                            <button @click="advisorysub($event,value.refsid)" class="btn btn-primary"
                                    style="width: 100px;">Save
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'consultDialog',
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      codeUrl: 'https://www.imsilkroad.com/api/pc/captcha/' + Date.parse(new Date())
    }
  },
  methods: {
    advisorysub () {
      this.$emit('saveConsult', this.value)
    },
    refresh () {
      $('#code').attr('src', 'https://www.imsilkroad.com/api/pc/captcha/' + Date.parse(new Date()))
    }
  }
}
</script>

<style scoped>
    /deep/ .modal {
        display: block !important;
    }

    .reqiureClass {
        color: red;
        padding-right: 5px;
    }
</style>
